import { useLocalStorage } from '@uidotdev/usehooks';

export const SELECTED_MICROPHONE_DEVICE_LOCAL_STORAGE_KEY = 'selectedMic';

/**
 * [ENG-5490] Metadata about the persisted mic selection, in a SEPARATE key so
 * `selectedMic` keeps its bare-deviceId shape — old cached bundles read that
 * key directly and must keep working across a rolling deploy.
 */
export const SELECTED_MICROPHONE_META_LOCAL_STORAGE_KEY = 'selectedMicMeta';

export type SelectedMicrophoneMeta = {
  /** Device label at selection time — the replug-stable identity used to
   * recover the selection when Windows mints a new deviceId. */
  label: string;
  /** `manual` = explicit dropdown pick (sticky: auto switch-back must never
   * override it); `auto` = chosen by the repair/priority logic. */
  source: 'manual' | 'auto';
};

export const useSelectedMicrophoneDevice = () => {
  return useLocalStorage<string | null>(
    SELECTED_MICROPHONE_DEVICE_LOCAL_STORAGE_KEY,
    null,
  );
};

export const useSelectedMicrophoneMeta = () => {
  return useLocalStorage<SelectedMicrophoneMeta | null>(
    SELECTED_MICROPHONE_META_LOCAL_STORAGE_KEY,
    null,
  );
};

export const getSelectedMicrophoneDevice = () => {
  return localStorage.getItem(SELECTED_MICROPHONE_DEVICE_LOCAL_STORAGE_KEY);
};
